<template>
  <v-container grid-list-xl fluid >
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat class="elevation-0 mx-5 offset-holder">
          <div class="pa-10">
            <superadmin-app-list slot="list"></superadmin-app-list>
          </div>
        </v-card>
      </v-flex>
       <superadmin-app-add></superadmin-app-add>
       <superadmin-app-edit></superadmin-app-edit>
       <superadmin-app-show-resources></superadmin-app-show-resources>
       <superadmin-app-add-to-business></superadmin-app-add-to-business>
      <superadmin-app-add-resources></superadmin-app-add-resources>
    </v-layout>

     <v-tooltip  slot="action" top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="addModal()"
          v-on="on"
          fixed
          dark
          fab
          bottom
          right
          depressed
          color="primary"
        >
          <v-icon dark v-on="on">add</v-icon>
        </v-btn>
      </template>
      <span>Add New App</span>
    </v-tooltip>
    
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import SuperadminAppList from './PageComponents/SuperadminApps/List';
import SuperadminAppAdd from './PageComponents/SuperadminApps/Add';
import SuperadminAppEdit from './PageComponents/SuperadminApps/Edit';
import SuperadminAppAddToBusiness from './PageComponents/SuperadminApps/AddAppToBusiness';
import SuperadminAppAddResources from './PageComponents/SuperadminApps/AddResources';
import SuperadminAppShowResources from './PageComponents/SuperadminApps/ShowResources';

export default {
  components: {
    SuperadminAppList,  
    SuperadminAppAdd,
    SuperadminAppAddToBusiness,
    SuperadminAppAddResources,
    SuperadminAppShowResources,
    SuperadminAppEdit,
  },
  data() {
    return {
    };
  },

  mounted() {
  
  },
  methods: {
    
    addModal() {
      this.setAdd(true);
    },

    ...mapActions({
      setAdd: 'superadminapps/setAdd',
    }),

  }
};
</script>

